define(['text!./templates/mfp-partner-link.html',
], (templateStr) => {

    return [() => {
        return {
            restrict: 'EA',
            scope: {
                translationKey: '@',
                partnerUrlTranslationKey: '@',
            },
            template: templateStr,
            controller: ['$scope', 'ContextService', 'MagnoliaService', ($scope, ContextService, MagnoliaService) => {
                $scope.getPartner = () => {
                    if (ContextService.getChannel()) {
                        return ContextService.getChannel().toUpperCase();
                    }
                };
                $scope.getPartnerLink = () => {
                    return MagnoliaService.getProductDocumentsLink();
                };
            }],
        };
    }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPPartnerLink.js